var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _vm.checkPermi(["platform:statistics:home:index"])
        ? _c("base-info", { ref: "baseInfo" })
        : _vm._e(),
      _c("grid-menu", { staticClass: "mb14" }),
      _c("user-overview"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }